// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.black-color {
  color: #1A1A18;
}

.header {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 10px 0px;
  height: calc(100% - 80px);
  padding: 30px 15px;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  text-align: left;
  color: #072633;
}

.name {
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: var(--ion-color-black);
  text-align: left;
  border-bottom: 0.5px solid #939393;
  padding: 15px 0px;
}

p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: var(--ion-color-black) !important;
}

div {
  position: relative;
  transition: max-height linear 0.3s;
}
.active {
  max-height: -moz-fit-content;
  max-height: fit-content;
  overflow: auto;
  width: 100%;
  padding-top: 10px;
}

.inactive {
  max-height: 0;
  overflow: hidden;
}

.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: var(--ion-color-black);
  padding-left: 20px;
}

.nutrition-value {
  text-align: right;
  color: var(--ion-color-black);
  text-transform: uppercase;
  font-size: 10px;
  padding-right: 20px;
}

.border-top {
  border-top: 1px solid var(--color-black);
}

.allergens_title {
  font-family: BricolageGrotesque, sans-serif;
  font-size: 16px;
  color: var(--ion-color-black);
}

ul {
  margin: 0px;
  list-style-type: none;
  padding: 0;
}
ul li {
  font-size: 12px;
  text-align: left;
  color: #072633 !important;
  padding: 6px 0px;
}

.padding-top {
  padding-top: 15px;
}

.button {
  width: 95%;
  padding: 20px 0;
  margin-top: 20px;
  align-self: center;
}
.button .close {
  background: var(--randy-red);
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
}
.button .close:hover {
  background: var(--randy-red);
}
.button .close p {
  text-align: center;
  font-size: 17px;
  padding: 17px;
  font-weight: 700;
  color: var(--color-white) !important;
}

.cross-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.cross-icon:hover {
  background: #f2dbd9;
}

.footer-block {
  display: flex;
  flex-direction: column;
  box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);
}
.footer-block .allergen-section .allergen-note {
  font-family: BricolageGrotesque;
  font-size: var(--font-size-caption);
  font-weight: 500;
  line-height: var(--line-height-normal);
  color: var(--text-secondary-light);
  margin: 0;
  padding: var(--spacing-md);
  color: #072633 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAAF;AAMA;EACE,cAAA;AAJF;;AAOA;EACE,aAAA;EAEA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AALF;AASK;EACG,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAPR;AAQQ;EACG,YAAA;AANX;;AAYA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EAIA,eAAA;EACA,gBAAA;EAEA,gBAAA;EACA,cAAA;AAbF;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAEA,gBAAA;EACA,kCAAA;EAGA,iBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EAGA,wCAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,kCAAA;AApBF;AA0BA;EACE,4BAAA;EAAA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,gBAAA;AAxBF;;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EAGA,kBAAA;AAzBF;;AA2BA;EACE,iBAAA;EACA,6BAAA;EAEA,yBAAA;EAEA,eAAA;EACA,mBAAA;AA1BF;;AA4BA;EACE,wCAAA;AAzBF;;AA2BA;EACE,2CAAA;EACA,eAAA;EACA,6BAAA;AAxBF;;AA4BA;EACE,WAAA;EACA,qBAAA;EACA,UAAA;AAzBF;AA0BE;EACG,eAAA;EACA,gBAAA;EACA,yBAAA;EAGA,gBAAA;AA1BL;;AA6BA;EACE,iBAAA;AA1BF;;AA4BA;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAzBJ;AA0BE;EAEE,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAzBJ;AA0BI;EACE,4BAAA;AAxBN;AA0BI;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;AAxBN;;AA4BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AA1BF;AA2BE;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAzBN;AA2BE;EACI,mBAAA;AAzBN;;AA6BA;EACI,aAAA;EACA,sBAAA;EACA,wDAAA;AA1BJ;AA6BI;EACE,+BAAA;EACA,mCAAA;EACA,gBAAA;EACA,sCAAA;EACA,kCAAA;EACA,SAAA;EACA,0BAAA;EACA,yBAAA;AA3BN","sourcesContent":[".container {\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  // background: #EAEAEB;\n  &.activated {\n     // background: white;\n  }\n}\n.black-color {\n  color: #1A1A18;\n\n}\n.header {\n  display: flex;\n  // align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 10px 0px;\n  height: calc(100% - 80px);\n  padding: 30px 15px;\n  // text-transform: uppercase;\n\n  .icon_wrapper {\n     ion-icon {\n        height: 10px;\n        width: 10px;\n        rotate: 180deg;\n        transition: rotate 0.5s;\n        margin-left: 10px;\n        &.isOpen{\n           rotate: 0deg;\n        }\n     }\n  }\n}\n\n.title {\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n\n  // text-transform: uppercase;\n\n  font-size: 28px;\n  font-weight: 700;\n  // line-height: 16px;\n  text-align: left;\n  color: #072633\n\n  // color: var(--ion-color-black);\n}\n\n.name {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15px;\n  letter-spacing: 0.01em;\n  color: var(--ion-color-black);\n\n  text-align: left;\n  border-bottom: 0.5px solid #939393;\n  // text-transform: uppercase;\n\n  padding: 15px 0px;\n}\n\np {\n  padding: 15px 0px;\n  text-align: left;\n  font-family: AppFont, sans-serif;\n  font-size: 11.5px;\n  line-height: 20px;\n  letter-spacing: 0.01em;\n  // text-transform: uppercase;\n\n  color: var(--ion-color-black) !important;\n}\n\ndiv {\n  position: relative;\n  transition: max-height linear 0.3s;\n\n  ion-button {\n  }\n}\n\n.active {\n  max-height: fit-content;\n  overflow: auto;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.inactive {\n  max-height: 0;\n  overflow: hidden;\n}\n.nutrition-name {\n  font-size: 10px;\n  text-align: left;\n  color: var(--ion-color-black);\n\n\n  padding-left: 20px;\n}\n.nutrition-value {\n  text-align: right;\n  color: var(--ion-color-black);\n\n  text-transform: uppercase;\n\n  font-size: 10px;\n  padding-right: 20px;\n}\n.border-top {\n  border-top: 1px solid var(--color-black);\n}\n.allergens_title {\n  font-family: BricolageGrotesque, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-black);\n  // text-transform: uppercase;\n\n}\nul {\n  margin: 0px;\n  list-style-type: none;\n  padding: 0;\n  li {\n     font-size: 12px;\n     text-align: left;\n     color: #072633!important;\n\n    // text-transform: uppercase;\n     padding: 6px 0px;\n  }\n}\n.padding-top {\n  padding-top: 15px;\n}\n.button {\n    width: 95%;\n    padding: 20px 0;\n    margin-top: 20px;\n    align-self: center;\n  .close {\n\n    background: var(--randy-red);\n    text-align: center;\n    border-radius: 3px;\n    cursor: pointer;\n    &:hover {\n      background: var(--randy-red);\n    }\n    p {\n      text-align: center;\n      font-size: 17px;\n      padding: 17px;\n      font-weight: 700;\n      color: var(--color-white) !important;\n    }\n  }\n}\n.cross-icon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 25px;\n  height: 25px;\n  z-index: 99;\n\n  margin: 0px;\n  background: var(--color-white-accent);\n  width: 35px;\n  height: 35px;\n  padding: 0px;\n  z-index: 99;\n  ion-icon {\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n  }\n  &:hover {\n      background: #f2dbd9;\n  }\n}\n// Allergen Information\n.footer-block {\n    display: flex;\n    flex-direction: column;\n    box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);\n\n  .allergen-section {\n    .allergen-note {\n      font-family: BricolageGrotesque;\n      font-size: var(--font-size-caption);\n      font-weight: 500;\n      line-height: var(--line-height-normal);\n      color: var(--text-secondary-light);\n      margin: 0;\n      padding: var(--spacing-md);\n      color: #072633 !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
